import * as React from "react";
import { MarketDataApiModel } from "../apiModels/MarketDataApiModel";
import { RioValidator, RioIconButton, RioResources, RioInput, RioIf, RioApiGet, RioDateHelpers, RioForEach } from "rio.react.all";
import { ErrorModal } from "../modals/ErrorModal";
import { DataVineGridView } from "../components/GridView/GridView";
import { NavisionDocumentApiModel } from "../apiModels/NavisionDocumentApiModel";
import { IGridViewColumn } from "../components/GridView/IGridViewColumn";
import { IGridViewAction } from "../components/GridView/IGridViewAction";
import { AccountStatementApi } from "../apiLayer/AccountStatementApi";
import { UserApi } from "../apiLayer/UserApi";
import { UserApiModel } from "../apiModels/UserApiModel";


interface IRioAdminProps {
}

interface IRioAdminState {
    Results: MarketDataApiModel;
    testPDFAccountNo: string;
    users: Array<UserApiModel>;
    selectedCount: number;
    displayedItems: Array<UserApiModel>;
    responseError: string;
}
export class RioAdmin extends React.Component<IRioAdminProps, IRioAdminState> {
    constructor(props: Readonly<IRioAdminProps>) {
        super(props);

        this.state = {
            Results: null,
            testPDFAccountNo: "",
            users: [],
            selectedCount: 0,
            displayedItems: [],
            responseError: null
        };
    }

    private validator = new RioValidator();
    private gridviewRef = React.createRef<DataVineGridView<UserApiModel>>();

    columns: Array<IGridViewColumn<UserApiModel>> = [
        { title: RioResources.find("ID").text, value: (item) => item.userID },
        { title: RioResources.find("Name").text, value: (item) => item.firstName + " " + item.lastName },
        { title: RioResources.find("Email").text, value: (item) => item.email }
    ];

    actions: Array<IGridViewAction<UserApiModel>> = [
        { resource: RioResources.find("Delete"), onClick: (item) => null, default: false, hasPermission: true }
    ];

    render() {
        return (
            <React.Fragment>
                <div>
                    <RioIconButton resource={RioResources.find("Test")} onClick={() => this.handleTestButtonClicked()} hasPermission={true} />
                    <RioIconButton resource={RioResources.find("SeedMarketTables")} onClick={() => this.handleSeedButtonClicked()} hasPermission={true} />
                    <RioIconButton resource={RioResources.find("UpdateMarketTables")} onClick={() => this.handleUpdateMarketValuesButtonClicked()} hasPermission={true} />
                    <RioIconButton resource={RioResources.find("BatchTest")} onClick={() => this.handleBatchTest()} hasPermission={true} />
                    <RioIconButton resource={RioResources.find("UpdateLivExCurrent")} onClick={() => this.handleLivExCurrent()} hasPermission={true} />
                    <RioIconButton resource={RioResources.find("UpdateLivExHistory")} onClick={() => this.handleLivExHistory()} hasPermission={true} />
                    <RioIconButton resource={RioResources.find("SuperTest")} onClick={() => this.superTest()} hasPermission={true} />
                    <RioIconButton resource={RioResources.find("APITest")} onClick={() => this.apiTest()} hasPermission={true} />
                </div>
                <div>
                    <div className="testPDFAccountWrapper">
                        <RioInput name="Account" type="text" className="testPDFAccountInput" value={this.state.testPDFAccountNo} placeholder={RioResources.find("EnterAccountNo").text} onChange={(e) => this.setState({ testPDFAccountNo: e.target.value })} validator={this.validator} />
                        <RioIconButton resource={RioResources.find("TestPDF")} onClick={() => this.handlePDFTest()} hasPermission={true} />
                        <RioIconButton resource={RioResources.find("TestReservesListPDF")} onClick={() => this.handleReservesListPDFTest()} hasPermission={true} />
                        <RioIconButton resource={RioResources.find("TestReservesListExcel")} onClick={() => this.handleReservesListExcelTest()} hasPermission={true} />
                    </div>

                    <RioIf condition={!!this.state.responseError} then={
                        <ErrorModal text={this.state.responseError} onErrorModalClosed={() => this.setState({ responseError: null })} />
                    } />
                    
                </div>

                <br />
                <br />
                <br />
                <div>
                    <div className="accountStatementButtonsWrapper">
                        <div className="left">
                            <RioIconButton resource={this.state.selectedCount !== this.state.users.length ? RioResources.find("SelectAll") : RioResources.find("DeSelectAll")} hideImage={true} onClick={() => this.selectAndDeselectAll()} hasPermission={true} />
                            <RioIconButton resource={RioResources.find("SelectVisible")} hideImage={true} onClick={() => this.selectVisible()} hasPermission={true} />
                            <RioIconButton resource={RioResources.find("DisplaySelected")} hideImage={true} onClick={() => this.DisplaySelected()} hasPermission={true} />
                        </div>
                    </div>
                    <DataVineGridView<UserApiModel>
                        ref={this.gridviewRef}
                        noResults={RioResources.find("NoResultsFound")}
                        columns={this.columns}
                        actions={this.actions}
                        items={this.state.users}
                        pageSize={3}
                        rowKey={(item: UserApiModel) => item.userID}
                        rowIsSelectable={() => true}
                        selectableRowTitle={RioResources.find("Selected").text}
                        onSelectedChanged={(items) => {
                            this.setState({
                                selectedCount: items?.length ?? 0
                            });
                        }}
                    />
                </div>

                <RioForEach items={this.state.displayedItems} perform={(item, index) => {
                    return (
                        <div key={index}>
                            <span>{item.firstName} {item.lastName} - {item.email}</span>
                        </div>
                    );
                }} />
            </React.Fragment>
        );
    }

    componentDidMount(){
        UserApi.getUsers()
            .then((response) => {
                this.setState({
                    users: response
                });
            });
    }

    superTest() {
        const call = new RioApiGet<null>("api/RioAdmin/SuperTest");
        call.onDone = response => {
            if (response.success) {

            }
        }
        call.send();
    }

    apiTest() {
        const call = new RioApiGet<null>("api/RioAdmin/APITest");
        call.onDone = response => {
            if (response.success) {

            }
        }
        call.send();
    }

    selectAndDeselectAll() {
        if (this.state.selectedCount !== this.state.users.length) {
            this.gridviewRef.current.selectAll();
        } else {
            this.gridviewRef.current.deselectAll();
        }
    }

    selectVisible() {
        this.gridviewRef.current.selectVisibleItems();
    }

    DisplaySelected() {
        let selectedItems = this.gridviewRef.current.getSelectedItems();
        this.setState({
            displayedItems: selectedItems
        });
    }

    handlePDFTest() {
        if (!!this.state.testPDFAccountNo) {
            const call = new RioApiGet<null>("api/RioAdmin/TestPDF/" + this.state.testPDFAccountNo);
            call.onDone = response => {
                console.log(response);
            }
            call.sendAndGetFile();
        }
    }

    handleReservesListPDFTest() {
        if (!!this.state.testPDFAccountNo) {
            const call = new RioApiGet<null>("api/RioAdmin/TestReservesListPDF/" + this.state.testPDFAccountNo);
            call.onDone = response => {
                console.log(response);
            }
            call.sendAndGetFile();
        }
    }

    handleReservesListExcelTest() {
        if (!!this.state.testPDFAccountNo) {
            const call = new RioApiGet<null>("api/RioAdmin/TestExcelReservesList/" + this.state.testPDFAccountNo);
            call.onDone = response => {
                console.log(response);
            }
            call.sendAndGetFile();
        }
    }

    handleBatchTest() {
        const call = new RioApiGet<null>("api/RioAdmin/BatchSend");
        call.onDone = response => {
            console.log(response);
           
        }
        call.send();
    }

    handleLivExCurrent() {


        const call = new RioApiGet<null>("api/RioAdmin/UpdateLivExCurrent");
        call.onDone = response => {
            console.log(response);
        }
        call.send();
    }

    handleLivExHistory() {


        const call = new RioApiGet<null>("api/RioAdmin/UpdateLivExHistory");
        call.onDone = response => {
            console.log(response);
        }
        call.send();
    }

    handleTestButtonClicked() {
        //const call = new RioApiPost<null>("api/CampaignEmail/", `UploadPDF/${7}/1MCKE04`, "");
        const call = new RioApiGet<null>("api/RioAdmin/TestFunction");
        call.onDone = response => {
            if (response.success) {

            }
        }
        call.send();
    }

    handleSeedButtonClicked() {

        const call = new RioApiGet<null>("api/RioAdmin/SeedMarketTables");
        call.onDone = response => {
            if (response.success) {
            }
        }
        call.send();
    }

    handleUpdateMarketValuesButtonClicked() {

        const call = new RioApiGet<null>("api/RioAdmin/UpdateMarketTables");
        call.onDone = response => {
            if (response.success) {
 
            }
        }
        call.send();
    }
}